export default __webpack_public_path__ + "static/lo-fly-dirt-1000-987-9051908c8bccc1515e83c2caca7e84b4.gif";